import { TABLE_MAX_ROW_EXPANSION_PANEL_HEIGHT, TABLE_ROW_HEIGHT } from "@/Constants/tables";
import { DEFAULT_ROW_EXPANSION_PANEL_HEIGHT } from "@/Layouts/components/Tables/DataSmartTable";

export const computeRowExpansionPanelHeight = (rows = 0) =>
	Math.max(
		DEFAULT_ROW_EXPANSION_PANEL_HEIGHT,
		Math.min(DEFAULT_ROW_EXPANSION_PANEL_HEIGHT + rows * TABLE_ROW_HEIGHT, TABLE_MAX_ROW_EXPANSION_PANEL_HEIGHT)
	);
